/** Persistence adapter. The game can also use an in-memory implementation. */
export class BrowserGameStore {
  constructor(storage, key) {
    this.storage = storage;
    this.key = key;
    this.available = true;
  }
  load() {
    try {
      return JSON.parse(this.storage.getItem(this.key));
    } catch {
      this.available = false;
      return null;
    }
  }
  save(value) {
    try {
      this.storage.setItem(this.key, JSON.stringify(value));
      this.available = true;
      return true;
    } catch {
      this.available = false;
      return false;
    }
  }
}
